import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const CullingDetailManager = () => {
  const [culling, setCulling] = useState({});
  const [status, setStatus] = useState(1);
  const [editors, setEditors] = useState([]); // List of editors
  const [selectedEditor, setSelectedEditor] = useState(""); // Selected editor
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  const getCullingById = async () => {
    try {
      const response = await axios.get(`/culling/${id}`);
      setCulling(response.data);
      setSelectedEditor(response.data.editor || "");
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1);
    } catch (error) {
      console.log(error);
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  const getEditors = async () => {
    try {
      const response = await axios.get("/user/allUsers");
      const editorUsers = response.data.filter(
        (user) => user.role === "editor"
      );
      setEditors(editorUsers);
    } catch (error) {
      console.error("Error fetching editors:", error);
    }
  };

  useEffect(() => {
    getCullingById();
    getEditors();
  }, []);

  const updateCulling = async () => {
    try {
      await axios.put(`/culling/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/culling-manager");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <div className="container mt-4">
        {errorMessage && (
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              class="btn-close shadow-none"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        )}
        <div className="row">
          {/* Left Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Service Type:</strong> {culling?.serviceId?.service}
                </p>
              </div>
            </div>{" "}
            <div className="card mb-3">
              <div className="card-header fw-600">Order Detail</div>
              <div className="card-body">
                <p>
                  <strong>Culling Percentage:</strong>{" "}
                  {culling.culling_percentage}
                </p>{" "}
                <p>
                  <strong>Keep my labels,flag and rating :</strong>{" "}
                  {culling.labels_flag_rating}
                </p>{" "}
                <p>
                  <strong>Output Format :</strong> {culling.output_format}
                </p>
                <p>
                  <strong>Quantity :</strong> {culling.quantity}
                </p>{" "}
                <p>
                  <strong>Social media :</strong> {culling.social_media}
                </p>{" "}
                <p>
                  <strong>Link :</strong> {culling.drive_link}
                </p>{" "}
                <p>
                  <strong>Aditional notes :</strong> {culling.additional_notes}
                </p>{" "}
                <p>
                  <strong>Upload :</strong> {culling.images}
                </p>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Order Operations</div>
              <div className="card-body">
                <p>
                  <strong>Client ID:</strong> {culling.userId?.id}
                </p>
                <p>
                  <strong>Order ID:</strong> {culling?.id}
                </p>
                <p>
                  <strong>User Feedback:</strong> {culling?.sampleFeedback}
                </p>
                <p>
                  <strong>Order Place Date:</strong>{" "}
                  {new Date(culling?.createdAt).toLocaleDateString()}
                </p>

                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>
                <div className="mt-3">
                  <label className="form-label">Select Editor</label>
                  <select
                    className="form-select"
                    value={selectedEditor}
                    onChange={(e) => setSelectedEditor(e.target.value)}
                  >
                    <option value="">Select an editor</option>
                    {editors.map((ed) => (
                      <option key={ed._id} value={ed.fname}>
                        {ed.fname}
                      </option>
                    ))}
                  </select>
                </div>

                <label className="form-label mt-3">File Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={fileLocation}
                  onChange={(e) => setFileLocation(e.target.value)}
                />
                <div>
                  <label className="form-label mt-3">Message</label>
                  <input
                    type="text"
                    className="form-control"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>

                <button
                  onClick={updateCulling}
                  className="btn text-light bg_maincolor mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CullingDetailManager;
